import React from 'react'
import * as S from './styles'
import { BaseCol } from '../BaseCol'

interface ISectionBaseProp {
  children: React.ReactNode
  title?: string | undefined
  style?: React.CSSProperties
  extra?: React.ReactNode
}

export const SectionBase: React.FC<ISectionBaseProp> = ({
  children,
  title,
  style,
  extra,
}) => {
  return (
    <S.BaseSection style={style}>
      {(title ||
        extra) && (
          <S.Title justify={"space-between"} align={"middle"}>
            <BaseCol>
              <h3>{title ?? ' '}</h3>
            </BaseCol>
            <BaseCol>{extra}</BaseCol>
          </S.Title>
        )}
      {children}
    </S.BaseSection>
  )
}
